import ChangeCloseDate from './components/ChangeCloseDate';
import inviteNewProviders from './components/inviteNewProviders';

export default {
  request: {
    header: {
      title: 'Information request',
      button1: 'Modify RFI term',
      button2: 'Invite Suppliers',
    },
    body: {
      row1: {
        label1: 'RFI N°',
        label2: 'RFI name',
        label3: {
          title: 'RFI Status',
          option1: 'Published',
          option2: 'Closed',
        },
      },
      row2: {
        label1: 'Notes',
        label2: 'Close date',
        label3: {
          title: 'Attachment',
          option1: 'See attachment',
        },
      },
      row3: {
        tab1: 'RFI´s',
        tab2: 'Responses',
        row: {
          label1: 'Vendor',
          label2: 'Item',
          label3: {
            title: 'registered',
            option1: 'Yes',
            option2: 'No',
          },
          label4: {
            title: 'Reviewed',
            option1: 'Yes',
            option2: 'No',
          },
          label5: {
            title: 'Answered',
            option1: 'Yes',
            option2: 'No',
          },
        },
        tabpanel: {
          label1: 'Comparison Chart - Price and availability',
          label2: 'RFI',
          label3: 'Requested',
          label4: 'vendors',
          label5: 'Comparison Chart - Technical answers',
          label6: 'Information request',
          label7: 'Suppliers',
        },
        gen_excel_button: ' Excel download ',
      },
      empty_answer: 'No answers found for the information request.',
    },
    script: {
      components: {
        ...ChangeCloseDate,
        ...inviteNewProviders,
      },
      generateExcel: {
        title: 'Generate Excel',
        message: 'There is no data to be able to generate the file',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/request_information/request.js